import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-405300c7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mockExamlistContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "模拟考试", -1));
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_PaperList = _resolveComponent("PaperList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "wd100 wbg pd12"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        icon: "Plus",
        type: "primary",
        onClick: $options.createExam
      }, {
        default: _withCtx(() => [_createTextVNode("新建考试")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "pd12 wbg mt12 flex flex-col",
      style: {
        "width": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.examList,
        style: {
          "width": "100%"
        },
        ref: "table"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID"
        }), _createVNode(_component_el_table_column, {
          prop: "planName",
          label: "考试名称"
        }), _createVNode(_component_el_table_column, {
          prop: "assessmentId",
          label: "考试编号"
        }), _createVNode(_component_el_table_column, {
          prop: "assessmentLevel",
          label: "考试编号"
        }), _createVNode(_component_el_table_column, {
          prop: "initialPaperExist",
          label: "初试"
        }), _createVNode(_component_el_table_column, {
          prop: "retakePaperExist",
          label: "复试"
        }), _createVNode(_component_el_table_column, {
          prop: "updatedTime",
          label: "更新时间"
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          "min-width": "120"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => $options.handelEdit(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: _withModifiers($event => $options.handelDelete(scope.row), ["prevent"])
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => $options.handelAddPaper(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 配置试卷 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => $options.copyExamPlan(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 复制 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.examDialogFormVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.examDialogFormVisible = $event),
    title: "模拟考试",
    width: "500"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: _cache[5] || (_cache[5] = $event => $data.examDialogFormVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.editSave
    }, {
      default: _withCtx(() => [_createTextVNode(" 保存 ")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.form
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "考试名称"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.planName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.planName = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "考试编号"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.assessmentId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.assessmentId = $event),
          autocomplete: "off",
          placeholder: "ASS001"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "考试等级"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.assessmentLevel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.assessmentLevel = $event),
          autocomplete: "off",
          placeholder: "模拟"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "考试类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.examType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.examType = $event),
          style: {
            "width": "240px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            key: "Practice",
            label: "课堂练习",
            value: "Practice"
          }), _createVNode(_component_el_option, {
            key: "Mock",
            label: "模拟考试",
            value: "Mock"
          }), _createVNode(_component_el_option, {
            key: "Exam",
            label: "正式考试",
            value: "Exam"
          }), _createVNode(_component_el_option, {
            key: "Final",
            label: "结业考试",
            value: "Final"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "用户组别"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.userGroupIds,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.userGroupIds = $event),
          placeholder: "用户组别，多选",
          style: {
            "width": "240px"
          },
          multiple: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.groupList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue"]), $data.paperDialogTableVisible ? (_openBlock(), _createBlock(_component_el_dialog, {
    key: 0,
    modelValue: $data.paperDialogTableVisible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.paperDialogTableVisible = $event),
    title: "配置试卷",
    width: "1200"
  }, {
    default: _withCtx(() => [$data.paperDialogTableVisible ? (_openBlock(), _createBlock(_component_PaperList, {
      key: 0,
      examPlanId: $data.examPlanId
    }, null, 8, ["examPlanId"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
}